export default {
  getCreditCardPayments(state) {
    return state.creditCardPayments || [];
  },
  getEnabledPaymentMethods(state) {
    return state.enabledPaymentMethods;
  },
};
